module.exports = __webpack_public_path__ + "img/home.44f1f851.svg";